/**
 * The deadline every boot fetch carries.
 *
 * `retryWithBackoff` only acts when its `run` REJECTS, so a request that never settles gets none of
 * decision 17's three attempts and never reaches the boot boundary either: the loader simply sat on
 * "Connecting..." for as long as the browser kept the socket open. A bounded request rejects with a
 * plain `Error`, so the existing retries and the boundary start working with no change to either.
 *
 * `AbortSignal.timeout` rather than an AbortController and a timer: it is not one of the globals the
 * wall-clock lint rule bans, which matters because half the boot's fetch sites (`money/`, `assets/`,
 * `branding/OperatorLoaderBranding.ts`) sit outside that rule's exempt list. It also stays armed
 * through the response BODY, not just the headers.
 *
 * The budget is per ATTEMPT: a fully stalled load costs this three times plus backoff (~32 s) before
 * the boundary shows the startup popup (user, 2026-09-22). Pixi's own `Assets.loadBundle` takes no
 * signal, so the bundle downloads that follow these loads remain unbounded.
 */
export const BOOT_REQUEST_TIMEOUT_MS = 10_000;
